import { useEffect, useState } from "react";
import "../css/Information.css";

const Information = () => {
  const [information, setInformation] = useState([]);

  useEffect(() => {
    fetch(
      "https://docs.google.com/spreadsheets/d/e/2PACX-1vTDPcICWae0NGejVSS2MBhtVVJCu6punpXCQnVQf_1pPAW_GZVoeRVhNqqwf1MHHHtHtM_DTzJ-aD76/pub?gid=0&single=true&output=csv"
    )
      .then((res) => res.text())
      .then((text) => {
        const rows = text.trim().split("\n");
        const parsed = rows.map((row) => {
          const [date, detail] = row.split(",");
          return { date, detail };
        });
        setInformation(parsed);
      });
  }, []);

  return (
    <div className="information-container">
      <div className="information-accordion">
        <div className="information-rest">
          {information.map((item, index) => (
            <div key={index} className="information-item">
              <div className="date">{item.date}</div>
              <div className="detail">{item.detail}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Information;
